import { NavLink } from "react-router-dom";
import OpenNewTab from "../hooks/OpenNewTab";

const LogoCarouselLayout = (props) => {
    const {openInNewTab} = OpenNewTab();
  return (
    <>
      <div
        className="rounded-circle border border-info shadow p-3 mx-2 d-flex justify-content-center align-items-center"
        style={{ width: '160px', height: '160px' }}
        data-aos="fade-up"
      >
        <NavLink
          to=""
          onClick={(e) => openInNewTab(props.pageLink)}
          target="_blank"
          className="d-flex justify-content-center align-items-center w-100 h-100"
        >
          <img
            src={props.imgsrc}
            alt={props.alt}
            style={{ maxWidth: '120px', maxHeight: '120px', objectFit: 'contain' }}
          />
        </NavLink>
      </div>
    </>
  )
}

export default LogoCarouselLayout